module.exports = __webpack_public_path__ + "img/patient-and-gp-talking.69e6a19a.jpg";